import { render, staticRenderFns } from "./intro-content.vue?vue&type=template&id=95ab12d2&"
import script from "./intro-content.vue?vue&type=script&lang=js&"
export * from "./intro-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports